module.exports = __webpack_public_path__ + "static/media/manas_nighrunkar.696901e9.jpg";